module.exports = __webpack_public_path__ + "f365760fc21230d3074c27b5d69a7ab5.png";